import axios from "axios";
import React, { useEffect, useState } from "react";
import OrgChart from "./OrgChart";
import { useSelector } from "react-redux";
import PuffLoader from "react-spinners/PuffLoader";
import { css } from "@emotion/react";
import Nav from "./Nav";
import _ from "lodash";

const override = css`
  display: block;
  margin: auto;
  border-color: red;
`;

const SponsorTree = () => {
  const address = useSelector((state) => state.address.value);
  const [isLoading, setLoading] = useState(true);
  const [treeData, setTreeData] = useState(null);

  useEffect(() => {
    getUserTreeData();
  }, []);

  function generateTree(users) {
    let root = users[0];
    let usersMap = {};

    users.forEach((u) => {
      // console.log(u);
      usersMap[u.id] = u;
    });

    users.forEach((u) => {
      try {
        let userId = u.id;
        let user = usersMap[userId];
        let parentId = user.pid;

        if (root.id === userId) {
          // is root
        } else {
          let parent = usersMap[parentId];

          if (parent) {
            if (!parent.children) {
              parent.children = [];
            }
            parent.children.push(user);
          } else {
            alert(userId + "의 부모가 없습니다.");
          }
        }
      } catch (e) {
        console.error(e);
      }
    });

    return root;
  }

  function sponsorPostorder(user) {
    if (user) {
      let leftSum = 0;
      let rightSum = 0;

      if (user.children) {
        let children = user.children;
        let childrenCount = children.length;

        if (childrenCount >= 1) {
          let leftChild = children[0];
          sponsorPostorder(leftChild);

          if (!leftChild.leftSum) {
            console.error(user.id + "의 left 자식이 정산되어 있지 않습니다.");
          }
          leftSum +=
            leftChild.leftSum + leftChild.rightSum + leftChild.vaild_deposit;
        }

        if (childrenCount >= 2) {
          let rightChild = children[1];
          sponsorPostorder(rightChild);
          if (rightChild.rightSum) {
            console.error(user.id + "의 right 자식이 정산되어 있지 않습니다.");
          }
          rightSum +=
            rightChild.leftSum + rightChild.rightSum + rightChild.vaild_deposit;
        }

        if (childrenCount >= 3) {
          console.error(
            user.id +
              "의 자식이 " +
              childrenCount +
              "개입니다.(2개 이상이면 오류)"
          );
        }
      }

      user.leftSum = leftSum;
      user.rightSum = rightSum;

      if (user.deposit === 0) {
        //자신의 몸값이 0이면 왼쪽도 0으로 표시하기 위해
        user.leftFix = 0;
        user.rightFix = 0;
      } else {
        user.leftFix = user.leftSum;
        user.rightFix = user.rightSum;
      }
    }
  }

  function getUserTreeData() {
    axios
      .post("api/getUserSponsorTreeData", {
        address: address,
      })
      .then((res) => {
        let data = res.data;

        // 자식의 왼쪽/오른쪽을 항상 동일하게 하기 위해 id로 정렬함.
        data = _.sortBy(data, "id");

        data.map((n) => {
          n.tags = ["t" + n.deposit];
          n.split = "|";

          n.vaildDeposit = n.deposit;
          if (n.vaild_deposit !== n.deposit) {
            n.vaildDeposit = n.deposit + " → " + n.vaild_deposit;
          } else {
            n.vaildDeposit = n.deposit;
          }
          return n;
        });

        let tree = generateTree(data);
        tree.vaildDeposit = tree.deposit;
        sponsorPostorder(tree);

        setTreeData(data);
        setTimeout(() => {
          setLoading(false);
        }, 300);
      })
      .catch((err) => {
        setLoading(false);
        if (err.response) {
          console.log(err.response);
        }
      });
  }

  function Tree() {
    let nodes = treeData;
    return (
      <div>
        <OrgChart nodes={nodes} type="sponsor" />
      </div>
    );
  }
  function Loading() {
    return <PuffLoader color="#fff" loading={true} css={override} size={50} />;
  }

  return (
    <div className="tree-container">
      <div className="tree-content">
        {/* <div className="title">
                        <p className="tree-title">Referral Tree</p>
                    </div> */}
        <div
          className="tree-wrap"
          style={{ display: isLoading ? "none" : "block" }}
        >
          <Tree></Tree>
        </div>
        <div
          className="tree-wrap"
          style={{
            display: isLoading ? "flex" : "none",
            justifyContent: "center",
          }}
        >
          <Loading></Loading>
        </div>
      </div>
      <Nav />
    </div>
  );
};

export default SponsorTree;
